module.exports = __webpack_public_path__ + "static/media/company-home-10.444e25af.png";